import React from "react";

const ImageDownload = () => {
  return (
    <svg
      width="39"
      height="31"
      viewBox="0 0 39 31"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M0 3.02167C0 1.66189 1.10232 0.55957 2.46209 0.55957H36.2599C37.6197 0.55957 38.722 1.66189 38.722 3.02166V27.8664C38.722 29.2262 37.6197 30.3285 36.2599 30.3285H2.46209C1.10231 30.3285 0 29.2262 0 27.8664V3.02167ZM8.84112 22.0904L2.90971 27.931H36.4837C36.1122 27.3489 35.6173 26.2334 35.0441 24.9413L35.044 24.9413C33.8907 22.3417 32.4204 19.0275 31 17.9061C27.7311 15.3252 25.3204 17.2577 24.1732 19.361C24.1133 19.4708 24.0489 19.5932 23.9796 19.7249L23.9796 19.7249C23.2722 21.0692 22.051 23.3899 19.8086 23.3899C17.9715 23.3899 17.6388 23.1035 16.512 22.1332C16.1973 21.8622 15.8207 21.5379 15.3321 21.1516C12.4286 18.8563 9.88564 20.8593 8.84112 22.0904ZM9.06493 15.556C12.3408 15.556 14.9963 12.9004 14.9963 9.62455C14.9963 6.34872 12.3408 3.69314 9.06493 3.69314C5.7891 3.69314 3.13352 6.34872 3.13352 9.62455C3.13352 12.9004 5.7891 15.556 9.06493 15.556Z"
        fill="#023A4A"
      />
    </svg>
  );
};

export default ImageDownload;
